import React, { useState, useEffect } from 'react';
import { useForm, useController, Controller, useFieldArray } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { updatePlan, createPlan, deletePlanVariant } from "../../slices/plans";
import { getPaymentProcessors } from "../../slices/paymentprocessors";
import { useNavigate } from 'react-router-dom';
import { SvgRecycleBin, SvgCancel } from "../svg";
import Select from '../select'
import useModal from "../../hooks/modal";
import Modal from "../../components/modal";

const translations = [
  gettext('Amount'),
  gettext('Please enter an amount'),
  gettext('Please enter a number'),
  gettext('Currency'),
  gettext('Please select a currency'),
  gettext('Select currency'),
  gettext('Reference'),
  gettext('Please input a reference'),
  gettext('Description'),
  gettext('Continue'),
]


const SinglePaymentForm = ({ callback, initial }) => {
  const [selectedMethod, setSelectedMethod] = useState('Card');
  const [paymentFormSelection, setSinglePaymentFormSelection] = useState('Email');
  const [selectedCard, setSelectedCard] = useState();
  const selectedCustomer = useSelector((state) => state.customers.selectedCustomer);
  const cardArray = useSelector((state) => state.customers.selectedCustomer?.payment_method);
  const currencies = useSelector((state) => state.currencies)

  const {
    register,
    trigger,
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    formState: { errors, isValid, isDirty }
  } = useForm({
    defaultValues: initial
  });

  const onSubmit = () => {
    callback(getValues())
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} >
        <div className="row">
          <div className="col-6 mb-4">
            <label>{gettext('Amount')}</label>
            <Controller
              control={control}
              rules={{
                required: gettext('Please enter an amount'),
                pattern: {
                  value: /^[0-9]+$/,
                  message: gettext('Please enter a number'),
                }
              }}
              name={`amount`}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <input
                  type="text"
                  ref={ref}
                  aria-label="First name"
                  className={`form-control ${errors.amount && "is-invalid"}`}
                  onBlur={onBlur}
                  onChange={onChange}
                  value={value}
                />
              )}
            />
            {errors.amount && <div className="">{errors.amount.message}</div>}
          </div>
          <div className="col-6 mb-4">
            <label>{gettext('Currency')}</label>
            <Controller
              control={control}
              rules={{
                required: gettext('Please select a currency'),
              }}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <Select
                  className="react-select col"
                  options={currencies}
                  onChange={(val) => onChange(val.code)}
                  onBlur={onBlur}
                  value={currencies.find(function (currency) {
                    return currency.code === value
                  })}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option.code}`}
                  placeholder={gettext('Select currency')}
                  innerRef={ref}
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      borderTopLeftRadius: '0',
                      borderBottomLeftRadius: '0',
                    }),
                  }}
                />
              )}
              name={`currency`}
            />
            {errors.currency && <div className="">{errors.currency.message}</div>}
          </div>
        </div>
        <div className="row">
          <div className="col-6 mb-4">
            <label>{gettext('Reference')}</label>
            <input type="text" {...register("reference", { required: gettext('Please input a reference') })} className={`form-control ${errors.reference && "is-invalid"}`} />
            {errors.reference && <div className="">{errors.reference.message}</div>}
          </div>
          <div className="col-6 mb-4">
            <label>{gettext('Description')}</label>
            <input type="text" {...register("description")} className="form-control" />
          </div>

          <button type="submit" className="form-control btn btn-primary">{gettext('Continue')}</button>
        </div>
      </form>
    </>)
};

export default SinglePaymentForm;
